import type { CvEducation, CvExperience, CvProject, GeneratedCv } from '../types';
import type { SavedCv } from '../services/cv';

// Reconstruit un GeneratedCv depuis une ligne `cvs` sauvegardée, pour rouvrir le CV dans la vue
// existante. `advice` n'est pas persisté (limitation connue) : on le renvoie vide.
export function savedCvToGeneratedCv(row: SavedCv): GeneratedCv {
  const c = row.content as Partial<GeneratedCv>;
  return {
    headline: c.headline ?? '',
    experiences: (c.experiences as CvExperience[]) ?? [],
    projects: (c.projects as CvProject[]) ?? [],
    education: (c.education as CvEducation[]) ?? [],
    skills: c.skills ?? [],
    languages: c.languages ?? [],
    interests: c.interests ?? [],
    ats_score: row.ats_score ?? 0,
    advice: [],
    // Un CV jamais noté n'a pas de score : 0 n'est qu'une valeur de remplissage.
    ...(row.ats_score == null ? { score_inconnu: true } : {}),
  };
}
